module.exports = __webpack_public_path__ + "img/pad_on_switch.789000ff.jpg";